import React, { Component } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import styled, { withTheme } from 'styled-components';
import { emptyFunction } from '../../core/util/function';
import { fontFamily, fontSize } from '../../constants/text';

type OwnProps = {
  theme?: any;
  panels?: {
    id: string;
    expandIcon?: any;
    onExpandOverride?: (...args: any[]) => any;
    title?: any;
    content?: any;
  }[];
};

type State = any;

type Props = OwnProps & typeof AccordionExpansionPanel.defaultProps;

class AccordionExpansionPanel extends Component<Props, State> {
  static defaultProps = {
    theme: {
      backgroundColor: 'white',
      width: '100%',
      a: {
        textDecoration: 'underlined',
      },
      panelDetails: {
        backgroundColor: 'white',
        p: {
          color: 'black',
          margin: '12px 0',
        },
      },
      panelSummary: {
        backgroundColor: 'white',
        p: {
          color: 'black',
        },
      },
    },
  };

  state = {
    expanded: null,
  };

  handleChange = (id: any) => (event: any, expanded: any) => {
    this.setState({
      expanded: expanded ? id : false,
    });
  };

  render() {
    const { panels, theme } = this.props;
    const { expanded } = this.state;

    const Root = styled.div`
      width: ${theme.width};
      background-color: ${theme.backgroundColor};
      a {
        text-decoration: ${theme.a.textDecoration};
      }
    `;

    const StyledAccordion = styled(Accordion)`
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2) !important;
      &::before {
        background-color: ${theme.backgroundColor}!important;
      }
    `;

    const StyledAccordionSummary = styled(AccordionSummary)`
      background-color: ${theme.panelSummary.backgroundColor}!important;
      p {
        color: ${theme.panelSummary.p.color};
        cursor: pointer;
      }
    `;

    const StyledAccordionDetails = styled(AccordionDetails)`
      background-color: ${theme.panelDetails.backgroundColor};
      p {
        color: ${theme.panelDetails.p.color};
        line-height: 24px;
        font-size: 12px;
        color: #dee6eb;
        cursor: pointer;
        font-family: ${fontFamily.book};
        margin: ${theme.panelDetails.p.margin};
        -webkit-font-smoothing: antialiased;
      }
      padding: 0 24px 10px !important;
    `;

    return (
      <Root>
        {/* @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'. */}
        {panels.map((panel) => (
          <StyledAccordion
            expanded={expanded === panel.id}
            key={panel.id}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'disableExpansion' does not exist on type... Remove this comment to see the full error message
            onChange={!panel.disableExpansion ? this.handleChange(panel.id) : emptyFunction}
          >
            <StyledAccordionSummary expandIcon={panel.expandIcon}>
              {panel.title}
            </StyledAccordionSummary>

            <StyledAccordionDetails>{panel.content}</StyledAccordionDetails>
          </StyledAccordion>
        ))}
      </Root>
    );
  }
}

export default withTheme(AccordionExpansionPanel);
